'use client';

import { useContext } from 'react';
import WorkspaceContext from './WorkspaceContext';

export function useSC(sc: string[]) {
  const { workspace } = useContext(WorkspaceContext);
  return workspace && sc.includes(workspace.sc);
}
